import { Injectable } from '@angular/core';
import { IZeitenMitarbeiterRequest, IZeitenMitarbeiterResponse } from 'fa-kt.types';

import { DetailQueryService } from 'pbc.angular';
import { IShape } from 'pbc.types';

@Injectable({
    providedIn: 'root',
})
export class ZeitenMitarbeiterService extends DetailQueryService<IZeitenMitarbeiterRequest, IZeitenMitarbeiterResponse, IShape> {
    override route = 'zeiten/mitarbeiter'
}
